<template>
  <div class="loading-view">
    <image-container
      :context="image"
      />
    <button
      @click="step">step
    </button>
  </div>
</template>

<script>
import ImageContainer from '@/components/ui/ImageContainer.vue'
export default {
  components: { ImageContainer },
  name: "LoadingView",
  data: () => ({
    image: {
      class: "loader-image",
      image: "landerpop_site_logo.png",
      alt: "I'm an image"
    },
    ukey: null,
    app: null
  }),
  async mounted () {
    this.setLoaded(false)
    
    this.ukey = this.$route.params.uKeyId
    this.app = this.$route.params.cid

    this.setCustId(this.app)
    this.setUser(this.ukey)

    this.$router.push({name: 'main'})
    
  }
}
</script>
